import { ELoginDesignId } from '@/lib/types/boot';

/** Product Madness serves its own legal pages instead of the publisher's. */
export const PRIVACY_POLICY_LINK_PRODUCT_MADNESS = 'https://www.productmadness.com/privacy-notice';
export const TERMS_AND_CONDITIONS_LINK_PRODUCT_MADNESS =
  'https://www.productmadness.com/terms-of-service';

const PRODUCT_MADNESS_LOGIN_DESIGN_IDS: ReadonlySet<ELoginDesignId> = new Set([
  ELoginDesignId.PRODUCT_MADNESS,
  ELoginDesignId.JACKPOT_SLOTS,
  ELoginDesignId.BIG_FISH_CASINO,
]);

/**
 * Every Product Madness store owes players the 18+ social-casino copy, whether
 * it runs the bespoke split-screen chrome or the default one. Keep this the
 * only place that decides, so a new design cannot ship without the disclaimer.
 */
export const isProductMadnessLoginDesign = (loginDesignId?: ELoginDesignId): boolean =>
  loginDesignId !== undefined && PRODUCT_MADNESS_LOGIN_DESIGN_IDS.has(loginDesignId);
